import DefaultClient, { InMemoryCache } from "apollo-boost";
import * as generated from "tcs-graphql/__generated__/types";
import * as operations from "tcs-graphql/operations";

export class TCSService {
  private client: DefaultClient<InMemoryCache>;

  constructor(endpoint: string) {
    this.client = new DefaultClient({
      uri: endpoint,
      headers: { credentials: "include" },
    });
  }

  public fetchPoisForRegionIdAndLocale(
    regionId: string,
    locale: string,
    limit?: number
  ): Promise<generated.TopPoiQuery> {
    // TODO we need a way to pass the locale here from the bernie context in a way that matches locale enum from the schema
    return this.client
      .query({
        query: operations.TopPoiQuery,
        variables: {
          regions: [regionId],
          limit,
          locale,
        },
      })
      .then((result) => {
        return result.data as generated.TopPoiQuery;
      });
  }
}
